export default __webpack_public_path__ + "static/media/full-dasboard-with-iPhone.5d7370b5.png";